import { useEffect, useRef } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useMsal } from '@azure/msal-react';
import { useCreateSession } from '../../api/session.ts';
import { completeRedirect, forgetEntraTokens } from '../../auth/msal.ts';
import { finishSignIn } from '../../auth/sign-in.ts';
import { CallbackPage } from '../../features/login/callback-page.tsx';

export const Route = createFileRoute('/auth/callback')({
  component: AuthCallbackRoute,
});

function AuthCallbackRoute(): React.JSX.Element {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const { mutateAsync: createSession } = useCreateSession();
  // StrictMode runs effects twice in development; the ID token must be posted only once.
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    void finishSignIn({
      completeRedirect: () => completeRedirect(instance),
      createSession,
      forgetTokens: () => forgetEntraTokens(instance),
    }).then((outcome) => {
      if (outcome.kind === 'signed_in') return navigate({ to: '/', replace: true });
      const search = outcome.kind === 'failed' ? { error: outcome.error } : {};
      return navigate({ to: '/login', search, replace: true });
    });
  }, [instance, navigate, createSession]);
  return <CallbackPage />;
}
